import { DashboardControllerApi } from "src/api/api";

export interface IDashboardApiClients {
    dashboard: DashboardControllerApi;
}
export class DashboardApiClients {
    private static instance: IDashboardApiClients;
  
    private constructor() {}
  
    static getInstance(basePath: string): IDashboardApiClients {
      if (DashboardApiClients.instance == null) {
        DashboardApiClients.instance = {
        dashboard: new DashboardControllerApi({
            basePath: basePath,
            isJsonMime() {
              return true;
            }
          }),
        };
      }
      return DashboardApiClients.instance;
    }
  }
  